import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_MDM(state) {
    Object.assign(state, getInitialState());
  },

  SET_MDM_PATIENT_INFO(state, mdmPatient) {
    state.data = mdmPatient;
  },

  SET_MDM_ID_PATIENT(state, mdmId) {
    state.data.id = mdmId;
  },

  SET_MDM_PATIENT_CONTACT_NUMBER_LIST(state, mobilePhoneList) {
    state.data.maskedContacts.mobilePhoneList = mobilePhoneList;
  },

  SET_MDM_PATIENT_CONTACT_EMAIL_LIST(state, emailList) {
    state.data.maskedContacts.emailList = emailList;
  },

  SET_PATIENT_KEYCLOAK(state, payload) {
    state.keycloak = payload;
  },
};

export default mutations;
